import { submitOnboardingResponses } from '../../data/services/onboardingQuestionsService';

/**
 * Convert answers object to the array format the API expects.
 * For multi-select answers, joins the selected values with commas.
 *
 * @param {Object} answers - { corps_function: 'combat', primary_work: 'field_operational', genai_goals: ['save_time', 'learn_ai'] }
 * @returns {Array<{questionKey: string, answerValue: string}>}
 */
function buildResponsesPayload(answers) {
  return Object.entries(answers).map(([questionKey, answerValue]) => ({
    questionKey,
    answerValue: Array.isArray(answerValue) ? answerValue.join(',') : answerValue,
  }));
}

/**
 * Submit all onboarding answers.
 * @param {Object} answers
 * @returns {Promise<{success: boolean, user: object}>}
 */
export async function submitAnswers(answers) {
  const responses = buildResponsesPayload(answers);
  return submitOnboardingResponses(responses);
}
